import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Footer from '../../components/Footer/Footer.component';
import { ContainerLimit } from './MainSite-style';
import Header from '../../components/Header/Header.component';
import React from 'react';

const MainSiteLayout = () => {
  return (
    <Box>
      <Header></Header>
      <ContainerLimit>
        <Outlet />
      </ContainerLimit>
      <Footer></Footer>
    </Box>
  );
};

export default MainSiteLayout;
